class ConfigService {
  constructor() {
    this.config = {};
  }

  addConfig(config) {
    this.config = {...this.config, ...config};
  }

  getItem(item) {
    return this.config[item];
  }

  getAll() {
    return this.config;
  }
}

export default new ConfigService();



// WEBPACK FOOTER //
// ./src/services/config.js